import { useCallback, useMemo, useState } from "react";
import {
  airPriceWatchApi,
  type Email,
  MessageMethodEnum,
} from "@b2bportal/air-price-watch-api";
import { CallState } from "@b2bportal/core-types";
import { emailRegex } from "@b2bportal/core-utilities";
import axios from "axios";
import type { ChangeWatchEmailModalContentComponentProps } from "./ChangeWatchEmailModalContent";

export const useChangeWatchEmailModalContent = (
  props: ChangeWatchEmailModalContentComponentProps
) => {
  const { watch } = props;
  const originalEmail = (watch.method as Email).email;
  const [email, setEmail] = useState(originalEmail);
  const [callState, setCallState] = useState(CallState.NotCalled);

  const isValidEmail = useMemo(() => {
    if (email && email !== "") {
      return emailRegex.test(email);
    }
    return false;
  }, [email]);

  const onChangeWatchEmail = useCallback(async () => {
    setCallState(CallState.NotCalled);
    if (originalEmail === email) {
      setCallState(CallState.Success);
    } else {
      try {
        airPriceWatchApi(axios).apiV0AlertWatchUpdatePost({
          key: watch.key,
          method: {
            email,
            MessageMethod: MessageMethodEnum.Email,
          },
        });
        setCallState(CallState.Success);
      } catch (e) {
        setCallState(CallState.Failed);
      }
    }
  }, [email, originalEmail, watch.key]);

  const onTryAgain = useCallback(() => {
    setCallState(CallState.NotCalled);
  }, []);

  return useMemo(() => {
    return {
      context: {
        watch: props.watch,
        tripContext: props.tripContext,
        email,
        callState,
        isValidEmail,
      },
      handlers: {
        refetch: props.refetch,
        onClose: props.onClose,
        setEmail,
        onTryAgain,
        onChangeWatchEmail,
      },
    };
  }, [
    callState,
    email,
    isValidEmail,
    onChangeWatchEmail,
    onTryAgain,
    props.onClose,
    props.refetch,
    props.tripContext,
    props.watch,
  ]);
};
